import { render, staticRenderFns } from "./ss-header.vue?vue&type=template&id=526c67ef&scoped=true"
import script from "./ss-header.vue?vue&type=script&lang=js"
export * from "./ss-header.vue?vue&type=script&lang=js"
import style0 from "./ss-header.vue?vue&type=style&index=0&id=526c67ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c67ef",
  null
  
)

export default component.exports